import { render } from "./PledgeDetailArea.vue?vue&type=template&id=282de835"
import script from "./PledgeDetailArea.vue?vue&type=script&lang=js"
export * from "./PledgeDetailArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__